import type { SearchTidLinkedAccountTypesQuery } from "@/api/graphql/types/graphql";

import type { LinkedAccountTypes } from "./types";

export const fromApiToTidLinkedAccountTypes = (
  response: SearchTidLinkedAccountTypesQuery,
): LinkedAccountTypes => {
  if (!response.BillingMsSearchTidLinkedAccountTypes?.data) {
    return {
      payerTypeIds: [],
      delegateTypeIds: [],
      customPayerTypeId: "",
      customDelegateTypeId: "",
    };
  }

  const result =
    response.BillingMsSearchTidLinkedAccountTypes.data.reduce<LinkedAccountTypes>(
      (acc, type) => {
        const id = type.id ?? "";
        const code = type.code?.toLowerCase() ?? "";

        if (code.includes("payer")) acc.payerTypeIds.push(id);
        if (code.includes("delegate")) acc.delegateTypeIds.push(id);
        if (code === "custom_payer") acc.customPayerTypeId = id;
        if (code === "custom_delegate") acc.customDelegateTypeId = id;

        return acc;
      },
      {
        payerTypeIds: [],
        delegateTypeIds: [],
        customPayerTypeId: "",
        customDelegateTypeId: "",
      },
    );

  return result;
};
